__webpack_require__.p = "https://assets.theyachtweek.com/_next/";